document.addEventListener('DOMContentLoaded', function() {
  var testimonialsElement = document.querySelector('.swiper-testimonials')

  if (testimonialsElement) {
    let breakpoint = window.matchMedia('(min-width: 1081px)');
    let testimonialsSwiper;
    function breakpointChecker() {
      if (breakpoint.matches == true) {
        if (testimonialsSwiper !== undefined) {
          testimonialsSwiper.destroy(true, true);
        }

        testimonialsElement.classList.add("swiper-initialized");
        return;
      } else {
        enableSwiper();
      }
    };

    enableSwiper();

    function enableSwiper() {
      testimonialsSwiper = new Swiper(testimonialsElement, {
        loop: true,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        pagination: {
          el: ".testimonials-pagination",
          clickable: true
        },
        navigation: {
          nextEl: '.testimonials-next',
          prevEl: '.testimonials-prev',
        },
      });
    };

    // breakpoint.addEventListener("change", breakpointChecker); // kickstart

    // window.addEventListener('resize', breakpointChecker);

    // breakpointChecker();
  }
});